import './style.less';

// Lambda lifetime in milliseconds
const lambdaLifetime = 5 * 60 * 1000;

// Time to enter steady delay in milliseconds
const initialDelayDuration = 5 * 1000;

// initial delay in milliseconds
const initialDelay = 500;

// max delay between tries in milliseconds
const steadyDelay = 2000;

const downloadBackoff = ($http, $log, $window, $timeout, url, delay, close, timeoutArr, totalDelay = 0) => {
  timeoutArr.push(
    $timeout(() => {
      $http
        .get(url)
        .then(() => {
          $window.open(url, '_blank');
          close();
        })
        .catch(() => {
          if (totalDelay < lambdaLifetime) {
            const newDelay = totalDelay < initialDelayDuration ? initialDelay : steadyDelay;
            const newTotalDelay = totalDelay + newDelay;

            downloadBackoff($http, $log, $window, $timeout, url, newDelay, close, timeoutArr, newTotalDelay);
          } else {
            timeoutArr.forEach(timeout => $timeout.cancel(timeout));
          }
        });
    }, delay)
  );
};

export default function(param) {
  return ($scope, $uibModalInstance, ApiClass, $log, Swal, $window, $http, $timeout) => {
    'ngInject';

    const { company_id, profile_uid, manage, report_type, params } = param;

    $scope.profile_uid = profile_uid;

    const timeoutArr = [];

    ApiClass.companiesIdTypePost(
      { id: company_id, type: 'reports' },
      { report_type, params, profile_uid },
      { queryParams: { manage } },
      true
    )
      .then(({ data: { item: { fileName, url } } }) => {
        $scope.fileName = fileName;
        $scope.url = url;

        downloadBackoff($http, $log, $window, $timeout, url, initialDelay, $scope.close, timeoutArr);
      })
      .catch(error => {
        $scope.close();

        $log.error(error);
        //logic need for swal based on status code;
        if (error.status === 0)
          return Swal.alert(
            'Error',
            'There was an error creating your report. Please try again and if the problem persists, please contact support@prolaera.com',
            'warning'
          );
        if (error.status === 422)
          return Swal.alert('Error', error.data.userMessage || error.data.message || error.data.info, 'warning');
        throw error;
      });

    $scope.close = () => {
      $uibModalInstance.dismiss('cancel');
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/reports/controller.js